import { render, staticRenderFns } from "./setpassword.vue?vue&type=template&id=0a2d1b53&scoped=true&"
import script from "./setpassword.vue?vue&type=script&lang=js&"
export * from "./setpassword.vue?vue&type=script&lang=js&"
import style0 from "./setpassword.vue?vue&type=style&index=0&id=0a2d1b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2d1b53",
  null
  
)

export default component.exports